import React from "react";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";
import {Grid} from "react-virtualized";

import LookListFeature from "../lookListFeature/lookListFeature";
import LookWizardSectionListFeature from "../lookWizard/lookWizardSectionListFeature";
import {wizardGroupInterface} from "../../../../../interfaces/wizardItemInterface";
import LookVirtualizedListLoadingItem from "./lookVirtualizedListLoadingItem";
// import LoadingSpinner from "../../ui/loadingSpinner";

export const getLookRowHeight = (lookViewType) => {
  return lookViewType === 1
    ? 104
    : lookViewType === 4
      ? 128
      : lookViewType === 2
        ? 171
        : 340
}

const LookVirtualizedList = (props) => {

  const {renderList, contentHeight, lookViewType, isMobile, updateLookCartItem, isWizard, wizardGroup, onScrollHandler,
    imageCanvas, maxClickCountReached, loadingCount} = props;

  if (!contentHeight || isNaN(contentHeight)) {
    return null
  }

  const width = isWizard ? 312 : 320;
  const columnWidth = lookViewType === 2
    ? width / 2
    : lookViewType === 4 ? width / 3 : width;
  const columnCount = lookViewType === 2
    ? 2
    : lookViewType === 4 ? 3 : 1;
  const rowCount = Math.ceil((loadingCount || renderList.length) / columnCount);

  const listSettings = {
    width,
    columnCount,
    columnWidth,
    rowCount,
    height: isMobile ? contentHeight - 16 : contentHeight - 116, // 52 header + 16 padding from bottom
    rowHeight: getLookRowHeight(lookViewType),
    overscanRowCount: 2,
    showScrollingPlaceholder: false,
    useDynamicRowHeight: false,
  }

  const cellRenderer = ({columnIndex, key, rowIndex, style}) => {
    if (loadingCount) {
      return <LookVirtualizedListLoadingItem style={style} key={key}/>
    }
    const navItem = renderList[(listSettings.columnCount * rowIndex) + columnIndex];
    if (!navItem) {
      return null
    }
    if (isWizard) {
      return <LookWizardSectionListFeature lookFeature={navItem.part}
                                           wizardGroup={wizardGroup}
                                           imageCanvas={imageCanvas}
                                           maxClickCountReached={maxClickCountReached}
                                           updateLookCartItem={updateLookCartItem}
                                           style={style}
                                           key={key}
                                           navItems={renderList}/>
    }
    return <LookListFeature style={style}
                            lookFeature={navItem.part}
                            key={key}
                            navItems={renderList}
                            updateLookCartItem={updateLookCartItem}/>
  }

  const noRowsRenderer = () => <div className={"ass-list"}>No Features found</div>;

  return (
    <Grid
      // ref="List"
      className={"virtualized-grid" + ((listSettings.rowCount * listSettings.rowHeight) > listSettings.height
        ? " virtualized-grid--with-scroll"
        : " virtualized-grid--without-scroll")}
      width={listSettings.width}
      height={listSettings.height}
      overscanRowCount={listSettings.overscanRowCount}
      rowCount={listSettings.rowCount}
      columnCount={listSettings.columnCount}
      columnWidth={listSettings.columnWidth}
      rowHeight={listSettings.rowHeight}
      onScroll={onScrollHandler}
      cellRenderer={cellRenderer}
      noRowsRenderer={noRowsRenderer}
    />
  )
};

LookVirtualizedList.propTypes = {
  imageCanvas: PropTypes.object,
  maxClickCountReached: PropTypes.func,
  updateLookCartItem: PropTypes.func,
  renderList: PropTypes.array,
  contentHeight: PropTypes.number,
  lookViewType: PropTypes.number.isRequired,
  isMobile: PropTypes.bool,
  onScrollHandler: PropTypes.func,
  isWizard: PropTypes.bool,
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  loadingCount: PropTypes.number,
}

export default injectIntl(LookVirtualizedList)
